import * as yup from 'yup';
import utils from 'shared/helpers/utils';
import { FORM_KEYS, CLIENT_CLASSIFICATION, TYPE_OF_INVESTMENT } from 'shared/constant';

const { translateAnswer } = utils;
const { PEP } = FORM_KEYS;
const { INSIDER_STATUS } = FORM_KEYS.CLIENT_PROFILE_FORM;

export const pepFieldsSchema = (intl, elementName, clientClassification, typeOfInvestment) => {
  switch (elementName) {
    case PEP.IS_PEP:
      return yup.object().shape({
        [PEP.IS_PEP]: yup
          .string()
          .nullable()
          .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
      });
    case INSIDER_STATUS:
      return yup.object().shape({
        [INSIDER_STATUS]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.insiderStatus' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.insiderStatus' }) }),
            (value) => {
              // console.log('insider ', value)
              if (clientClassification === CLIENT_CLASSIFICATION.RETAIL && typeOfInvestment === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && !value) {
                return true;
              }
              if (clientClassification !== CLIENT_CLASSIFICATION.RETAIL && typeOfInvestment !== TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && !value) return false;
              return true;
            },
          ),
      });
    default:
      return null;
  }
};

export const pepListSchema = (intl, isPep) => yup.object().shape({
  [PEP.BENEFICIARIES]: yup.array(
    yup.object().shape({
      [PEP.NAME]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
      [PEP.POSITION]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
      [PEP.OTHER_POSITION]: yup
        .string()
        .max(120, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: 120 }))
        .when(PEP.POSITION, {
          is: position => translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && position === 'NW-MAR-PEP-OT',
          then: yup.string().required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
        }),
      [PEP.RELATIONSHIP]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
    }),
  ),
});

export const pepPageSchema = (intl, isPep, clientClassification, typeOfInvestment) => yup.object().shape({
  [PEP.IS_PEP]: yup
    .string()
    .nullable()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [PEP.BENEFICIARIES]: yup.array(
    yup.object().shape({
      [PEP.NAME]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
      [PEP.POSITION]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
      [PEP.OTHER_POSITION]: yup
        .string()
        .max(120, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: 120 }))
        .when(PEP.POSITION, {
          is: position => translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && position === 'NW-MAR-PEP-OT',
          then: yup.string().required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
        }),
      [PEP.RELATIONSHIP]: yup
        .string()
        .test(
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
          (value) => {
            if (translateAnswer(isPep, intl) === intl.formatMessage({ id: 'yes' }) && !value) return false;
            return true;
          },
        ),
    }),
  ),
  [INSIDER_STATUS]: yup
    .string()
    // .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.insiderStatus' }) })),
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.insiderStatus' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'clientProfileForm.insiderStatus' }) }),
      (value) => {
        // console.log(clientClassification, CLIENT_CLASSIFICATION.RETAIL, typeOfInvestment, TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO, value);
        if (clientClassification === CLIENT_CLASSIFICATION.RETAIL && typeOfInvestment === TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && !value) {
          return true;
        }
        if (clientClassification !== CLIENT_CLASSIFICATION.RETAIL && typeOfInvestment !== TYPE_OF_INVESTMENT.IMARKAZ_PORTFOLIO && !value) return false;
        return true;
      },
    ),
});

// export default pepPageSchema;
